import React, { ReactElement } from "react";
import { styled, Typography } from "@mui/material";
import theme from "theme/default";
import {
  colors,
  fontSize,
  fontWeight,
  gaps,
  margin,
  padding,
} from "theme/defaultStyle";
import ErrorMessage from "./SectionErrorMessage";

type Props = {
  children: ReactElement;
  icon?: ReactElement | Element;
  title: string;
  titleRef?: any;
  isError?: boolean;
};

const PageHeader = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: gaps.small1,
  marginTop: padding.large1,
  marginBottom: padding.small1,
  marginLeft: padding.large1,
});

const PageTitle = styled(Typography)({
  color: colors.maroon03,
  fontWeight: fontWeight.bold2,
  fontSize: fontSize.xlarge0,
});

const CardContainer = styled("div")({
  backgroundColor: theme.custom.container.outer.root.backgroundColor,
  borderRadius: theme.custom.container.outer.root.borderRadius,
  boxShadow: theme.custom.container.outer.root.boxShadow ?? "",
  margin: margin.zero,
  padding: theme.custom.container.outer.root.padding,
});

const Content = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
  "& .MuiTypography-root.subheading": {
    color: colors.grey11,
    fontSize: fontSize.base,
    margin: margin.zero,
    padding: padding.zero,
  },
});

const PageSectionPageTitle = ({
  children,
  icon,
  title,
  titleRef,
  isError = false,
}: Props) => {
  return (
    <>
      <PageHeader ref={titleRef}>
        {icon}
        <PageTitle>{title}</PageTitle>
        {isError && <ErrorMessage />}
      </PageHeader>
      <CardContainer>
        <Content>{children}</Content>
      </CardContainer>
    </>
  );
};

export default PageSectionPageTitle;
